import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=0d283f5f&scoped=true"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"
import style0 from "./Roles.vue?vue&type=style&index=0&id=0d283f5f&prod&lang=scss&scoped=true"
import style1 from "./Roles.vue?vue&type=style&index=1&id=0d283f5f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d283f5f",
  null
  
)

export default component.exports